import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import SubHeader from './SubHeader';
import Footer from './Footer';
import AnnouncementBanner from './AnnouncementBanner';
import useScrollToTop from '../hooks/useScrollToTop';

const Layout = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  
  useScrollToTop();

  // Passive scroll listener that only updates state when crossing threshold
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrolled = window.scrollY > 70;
          setIsScrolled(prev => (prev !== scrolled ? scrolled : prev));
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  useEffect(() => {
    if (props.announcement?.isActive) {
        setIsBannerVisible(true);
    }
  }, [props.announcement]);

  const showBackButton = location.pathname !== "/";
  const handleBackClick = () => navigate(-1);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      {/* 1. Main Header (Scrolls naturally with the page - zero layout jump on mobile) */}
      <Header 
          {...props} 
          showBackButton={showBackButton} 
          onBackClick={handleBackClick}
          onMenuClick={props.onMenuClick}
          setShowCart={props.setShowCart}
          onSearchClick={props.onSearchClick}
          cartItemCount={props.cartItemCount}
      />

      {/* 2. SubHeader (Sticky at top-0 with zero layout reflow) */}
      <div className="sticky top-0 z-30">
          <SubHeader 
              isScrolled={isScrolled} 
              allProducts={props.allProducts}
              onMenuClick={props.onMenuClick}
              setShowCart={props.setShowCart}
              onSearchClick={props.onSearchClick}
              cartItemCount={props.cartItemCount}
              bundleSettings={props.bundleSettings}
          />
      </div>
      
      {/* Announcement Banner (Supports Single Text & Dynamic Multi-Slide Carousel) */}
      {props.announcement?.isActive && isBannerVisible && (
        <AnnouncementBanner
            announcement={props.announcement}
            onClose={() => setIsBannerVisible(false)}
        />
      )}
      
      <main className="flex-grow">
        <Outlet context={props} />
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
